export default __webpack_public_path__ + "static/media/linkedin.2b059ed4.svg";